const config = {
    MAX_FILE_SIZE_BYTES_DOCKER: 5 * 1024 * 1024 * 1024, // 5 GB
    MAX_FILE_SIZE_BYTES_MEDIA: 10 * 1024 * 1024, // 10 MB
    MAX_CHUNK_SIZE_BYTES: 1 * 1024 * 1024, // 1MB chunks
    SERVER_HOST: process.env.REACT_APP_BACKEND_SERVER_HOST || 'https://localhost:3001'
}
export default config;
